import React from 'react';
import PropTypes from 'prop-types';
import PropertyTypeCount from './property-type-count';
import {
  StyledPropertyTypeCounts,
  Heading,
  PropertyTypeCountList
} from './styles';

const PropertyTypeCounts = ({ location = {}, propertyTypeCounts = [] }) => {
  const relevantPropertyTypes = ['house', 'apartment', 'townhouse'];
  return (
    <StyledPropertyTypeCounts>
      <Heading>
        {location.suburb || location.town || location.province} properties for
        sale
      </Heading>
      <PropertyTypeCountList>
        {relevantPropertyTypes.map((propertyType) => (
          <PropertyTypeCount
            key={propertyType}
            propertyType={propertyType}
            location={location}
            count={propertyTypeCounts[propertyType]}
          />
        ))}
      </PropertyTypeCountList>
    </StyledPropertyTypeCounts>
  );
};

PropertyTypeCounts.propTypes = {
  propertyTypeCounts: PropTypes.object,
  location: PropTypes.object
};

export default React.memo(PropertyTypeCounts);
